import type { TimeRangeLane } from '../TimeSeriesChart.types';
import type { TimeSeriesChartTheme } from './TimeSeriesChartTheme.types';

export function getTimeRangeLaneColor(lane: TimeRangeLane, theme: TimeSeriesChartTheme): string {
  return lane.color ?? theme.rangeTrack.fallbackColor;
}
